// Render endpoints. The POST returns a JSON RenderBundle; the artifact GET is
// content-addressed (NOT site-scoped) and returns application/yaml, so it uses
// requestText (raw string), not request<T>. Mirrors api/v1/site_render.py.

import { request, requestText, type ApiResponse, type TextResponse } from "../client";
import type { RenderBundleOut } from "../types/renderBundle";

export const render = {
  renderRequest: (siteSlug: string): Promise<ApiResponse<RenderBundleOut>> =>
    request<RenderBundleOut>(
      "POST",
      `/api/v1/sites/${encodeURIComponent(siteSlug)}/render/request-artifacts`,
    ),
  artifact: (sha: string): Promise<TextResponse> =>
    requestText("GET", `/api/v1/render/artifacts/${encodeURIComponent(sha)}`),
};
